export default {
    systemThemePrimaryColor: "rgba(93, 89, 255, 1)",
    borderColor: "grey",
    lightColor: "rgb(237, 241, 248)",
}